import React from 'react'
import type { HTMLAttributes, MouseEvent } from 'react'
import dialogStyles from '../primitives/dialog.module.css'
import { CloseButton } from './close-button.js'
import styles from './dialog-title.module.css'

export interface DialogTitleProps extends HTMLAttributes<HTMLDivElement> {
  id?: string
  controls?: React.ReactNode
  children?: React.ReactNode
  onClose: (ev: MouseEvent) => void
}

export const DialogTitle = ({ id, title, children, controls = null, onClose, className, style, ...rest }: DialogTitleProps) => {
  const classes = [dialogStyles.title, styles.root, className].filter(Boolean).join(' ')
  return (
    <div
      id={id}
      className={classes}
      style={style}
      {...rest}
    >
      {title ? (
        <span className={styles.titleText}>
          {title}
        </span>
      ) : null}
      {children}
      {controls}
      <CloseButton onClose={onClose} />
    </div>
  )
}

export default DialogTitle
